export * from './side-menu.component';
export * from './side-menu.view-model';
